import { makeStyles } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import React from "react";
import { FormattedMessage } from "react-intl";
import { Link as RouterLink } from "react-router-dom";
import isChunkLoadError from "../../utils/isChunkLoadError";
import Button from "../buttons/Button";
const useStyles = makeStyles((theme) => ({
    root: ({ isNotFoundPage }) => ({
        display: "flex",
        alignItems: "center",
        padding: theme.spacing(5),
        minHeight: isNotFoundPage ? "100%" : "unset",
    }),
}));
export default function ErrorScreen({ isNotFoundPage, error }) {
    const classes = useStyles({ isNotFoundPage });
    const chunkLoadError = isChunkLoadError(error);
    const renderErrorTitle = () => {
        if (isNotFoundPage) {
            return React.createElement(FormattedMessage, { id: "ui-kit-error.pageNotFound" });
        }
        if (chunkLoadError) {
            return React.createElement(FormattedMessage, { id: "ui-kit-error.pleaseWait" });
        }
        return React.createElement(FormattedMessage, { id: "ui-kit-error.somethingWentWrong" });
    };
    return (React.createElement("div", { className: classes.root },
        React.createElement(Container, { maxWidth: "lg" },
            React.createElement(Typography, { variant: "h3", align: "center", color: "textPrimary", gutterBottom: true }, renderErrorTitle()),
            React.createElement(Typography, { variant: "h4", align: "center", color: "textPrimary" }, chunkLoadError ? (React.createElement(FormattedMessage, { id: "ui-kit-error.loadingLatestChanges" })) : (error === null || error === void 0 ? void 0 : error.message)),
            React.createElement(Box, { mt: 6, display: "flex", justifyContent: "center" }, !chunkLoadError && (React.createElement(Button, { to: "/", color: "primary", component: RouterLink, variant: "outlined" },
                React.createElement(FormattedMessage, { id: "ui-kit-backToHome" })))))));
}
ErrorScreen.defaultProps = {
    // When used as FallbackComponent for ErrorBoundary, component will always be passed these props.
    error: {
        name: "",
        message: "",
    },
    resetErrorBoundary: () => { },
};
//# sourceMappingURL=index.js.map